import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

// Upload images to Cloudinary via backend
export const uploadImages = async (files, token, path = "chat") => {
  try {
    const formData = new FormData();
    formData.append("path", path);

    for (let file of files) {
      formData.append("files", file);
    }

    const { data } = await axios.post(`${API_URL}/uploadImages`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    console.error("Error uploading images:", error);
    throw error;
  }
};

// Upload audio to Cloudinary
export const uploadAudio = async (audioBlob, token) => {
  try {
    const formData = new FormData();
    formData.append("path", "chat/audio");
    formData.append("files", audioBlob, `audio_${Date.now()}.webm`);

    const { data } = await axios.post(`${API_URL}/uploadImages`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    console.error("Error uploading audio:", error);
    throw error;
  }
};

// Upload video to Cloudinary
export const uploadVideo = async (videoFile, token) => {
  try {
    const formData = new FormData();
    formData.append("path", "chat/video");
    formData.append("files", videoFile);

    const { data } = await axios.post(`${API_URL}/uploadImages`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    console.error("Error uploading video:", error);
    throw error;
  }
};

// Upload document to Cloudinary
export const uploadDocument = async (documentFile, token) => {
  try {
    const formData = new FormData();
    formData.append("path", "chat/documents");
    formData.append("files", documentFile);

    const { data } = await axios.post(`${API_URL}/uploadDocuments`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    // Returns array of { url, name, size, mimeType }
    return data;
  } catch (error) {
    console.error("Error uploading document:", error);
    throw error;
  }
};

// Upload media for stories (images and videos) with progress
export const uploadStoryMedia = async (file, token, onProgress) => {
  try {
    const formData = new FormData();
    formData.append("path", "stories");
    formData.append("files", file);

    const { data } = await axios.post(`${API_URL}/uploadMedia`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const progress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          onProgress(progress);
        }
      },
    });

    return { status: "ok", data };
  } catch (error) {
    console.error("Error uploading story media:", error);
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao fazer upload",
    };
  }
};

// Get file type from extension
export const getFileType = (fileName) => {
  const extension = fileName.split(".").pop().toLowerCase();

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];
  const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi", "mkv"];
  const audioExtensions = ["mp3", "wav", "ogg", "m4a", "aac", "webm"];
  const documentExtensions = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt"];

  if (imageExtensions.includes(extension)) return "image";
  if (videoExtensions.includes(extension)) return "video";
  if (audioExtensions.includes(extension)) return "audio";
  if (documentExtensions.includes(extension)) return "document";

  return "document"; // Default
};

// Format file size
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

// Create thumbnail from video
export const createVideoThumbnail = (videoFile) => {
  return new Promise((resolve) => {
    const video = document.createElement("video");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    video.onloadedmetadata = () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
    };

    video.onseeked = () => {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        resolve(blob);
      }, "image/jpeg", 0.7);
    };

    video.src = URL.createObjectURL(videoFile);
    video.currentTime = 1; // Seek to 1 second
  });
};
